export enum HorizontalCRS {
  ARC_1950_UTM_ZONE_35S = 'Arc 1950 / UTM zone 35S',
  GGRS87_GREEK_GRID = 'GGRS87 / Greek Grid',
  GDA2020_MGA_ZONE_46 = 'GDA2020 / MGA zone 46',
  GDA2020_MGA_ZONE_47 = 'GDA2020 / MGA zone 47',
  GDA2020_MGA_ZONE_48 = 'GDA2020 / MGA zone 48',
  GDA2020_MGA_ZONE_49 = 'GDA2020 / MGA zone 49',
  GDA2020_MGA_ZONE_50 = 'GDA2020 / MGA zone 50',
  GDA2020_MGA_ZONE_51 = 'GDA2020 / MGA zone 51',
  GDA2020_MGA_ZONE_52 = 'GDA2020 / MGA zone 52',
  GDA2020_MGA_ZONE_53 = 'GDA2020 / MGA zone 53',
  GDA2020_MGA_ZONE_54 = 'GDA2020 / MGA zone 54',
  GDA2020_MGA_ZONE_55 = 'GDA2020 / MGA zone 55',
  GDA2020_MGA_ZONE_56 = 'GDA2020 / MGA zone 56',
  GDA2020_MGA_ZONE_57 = 'GDA2020 / MGA zone 57',
  GDA2020_MGA_ZONE_58 = 'GDA2020 / MGA zone 58',
  GDA94_MGA_ZONE_46 = 'GDA94 / MGA zone 46',
  GDA94_MGA_ZONE_47 = 'GDA94 / MGA zone 47',
  GDA94_MGA_ZONE_48 = 'GDA94 / MGA zone 48',
  GDA94_MGA_ZONE_49 = 'GDA94 / MGA zone 49',
  GDA94_MGA_ZONE_50 = 'GDA94 / MGA zone 50',
  GDA94_MGA_ZONE_51 = 'GDA94 / MGA zone 51',
  GDA94_MGA_ZONE_52 = 'GDA94 / MGA zone 52',
  GDA94_MGA_ZONE_53 = 'GDA94 / MGA zone 53',
  GDA94_MGA_ZONE_54 = 'GDA94 / MGA zone 54',
  GDA94_MGA_ZONE_55 = 'GDA94 / MGA zone 55',
  GDA94_MGA_ZONE_56 = 'GDA94 / MGA zone 56',
  GDA94_MGA_ZONE_57 = 'GDA94 / MGA zone 57',
  GDA94_MGA_ZONE_58 = 'GDA94 / MGA zone 58',
  NAD83_2011_WISCONSIN_SOUTH_FTUS = 'NAD83(2011) / Wisconsin South (ftUS)',
  NAD83_CSRS_UTM_ZONE_19N = 'NAD83(CSRS) / UTM zone 19N',
  SIRGAS_2000_UTM_ZONE_14N = 'SIRGAS 2000 / UTM zone 14N',
  SIRGAS_2000_UTM_ZONE_23S = 'SIRGAS 2000 / UTM zone 23S',
  SIRGAS_2000_UTM_ZONE_24S = 'SIRGAS 2000 / UTM zone 24S',
  TUREF_TM27 = 'TUREF / TM27',
  WGS84 = 'WGS84',
  WGS84_UTM_ZONE_18S = 'WGS84 / UTM zone 18S',
  WGS84_UTM_ZONE_19N = 'WGS84 / UTM zone 19N',
  WGS84_UTM_ZONE_19S = 'WGS84 / UTM zone 19S',
  WGS84_UTM_ZONE_20S = 'WGS84 / UTM zone 20S',
  WGS84_UTM_ZONE_21S = 'WGS84 / UTM zone 21S',
  WGS84_UTM_ZONE_22S = 'WGS84 / UTM zone 22S',
  WGS84_UTM_ZONE_23S = 'WGS84 / UTM zone 23S',
  WGS84_UTM_ZONE_24S = 'WGS84 / UTM zone 24S',
  WGS84_UTM_ZONE_25S = 'WGS84 / UTM zone 25S',
  WGS84_UTM_ZONE_42 = 'WGS84 / UTM zone 42',
  WGS84_UTM_ZONE_43 = 'WGS84 / UTM zone 43',
  WGS84_UTM_ZONE_44 = 'WGS84 / UTM zone 44',
  WGS84_UTM_ZONE_45 = 'WGS84 / UTM zone 45',
  WGS84_UTM_ZONE_46 = 'WGS84 / UTM zone 46',
  WGS84_UTM_ZONE_47 = 'WGS84 / UTM zone 47',
  WGS84_UTM_ZONE_48 = 'WGS84 / UTM zone 48',
  WGS84_UTM_ZONE_49 = 'WGS84 / UTM zone 49',
  WGS84_UTM_ZONE_50N = 'WGS84 / UTM zone 50N',
  WGS84_UTM_ZONE_50S = 'WGS 84 / UTM zone 50S',
  WGS84_UTM_ZONE_51N = 'WGS 84 / UTM zone 51N',
  WGS84_UTM_ZONE_52N = 'WGS 84 / UTM zone 52N',
  WGS84_UTM_ZONE_53N = 'WGS 84 / UTM zone 53N',
  WGS84_UTM_ZONE_54N = 'WGS 84 / UTM zone 54N',
  WGS84_UTM_ZONE_46S = 'WGS 84 / UTM zone 46S',
  WGS84_UTM_ZONE_47S = 'WGS 84 / UTM zone 47S',
  WGS84_UTM_ZONE_48S = 'WGS 84 / UTM zone 48S',
  WGS84_UTM_ZONE_49S = 'WGS 84 / UTM zone 49S',
  WGS84_UTM_ZONE_51S = 'WGS 84 / UTM zone 51S',
  WGS84_UTM_ZONE_52S = 'WGS 84 / UTM zone 52S',
  WGS84_UTM_ZONE_53S = 'WGS 84 / UTM zone 53S',
  WGS84_UTM_ZONE_54S = 'WGS 84 / UTM zone 54S',
}

export enum VerticalCRS {
  AHD71 = 'AHD71',
  BALTIC_1957 = 'Baltic 1957',
  BALTIC_1977 = 'Baltic 1977',
  BALTIC_1982 = 'Baltic 1982',
  BALTIC_1986 = 'Baltic 1986',
  CGVD2013 = 'CGVD2013',
  EGM2008 = 'EGM2008',
  EGM96 = 'EGM96',
  ELLIPSOIDAL = 'Ellipsoidal',
  IMBITUBA = 'IMBITUBA',
  INAGEOID_2020 = 'INAGEOID 2020',
  MAPGEO2015 = 'MAPGEO2015',
}

export enum EPSGCode {
  ARC_1950_UTM_ZONE_35S = 20935,
  GGRS87_GREEK_GRID = 2100,
  GDA2020_MGA_ZONE_46 = 7846,
  GDA2020_MGA_ZONE_47 = 7847,
  GDA2020_MGA_ZONE_48 = 7848,
  GDA2020_MGA_ZONE_49 = 7849,
  GDA2020_MGA_ZONE_50 = 7850,
  GDA2020_MGA_ZONE_51 = 7851,
  GDA2020_MGA_ZONE_52 = 7852,
  GDA2020_MGA_ZONE_53 = 7853,
  GDA2020_MGA_ZONE_54 = 7854,
  GDA2020_MGA_ZONE_55 = 7855,
  GDA2020_MGA_ZONE_56 = 7856,
  GDA2020_MGA_ZONE_57 = 7857,
  GDA2020_MGA_ZONE_58 = 7858,
  GDA94_MGA_ZONE_46 = 28346,
  GDA94_MGA_ZONE_47 = 28347,
  GDA94_MGA_ZONE_48 = 28348,
  GDA94_MGA_ZONE_49 = 28349,
  GDA94_MGA_ZONE_50 = 28350,
  GDA94_MGA_ZONE_51 = 28351,
  GDA94_MGA_ZONE_52 = 28352,
  GDA94_MGA_ZONE_53 = 28353,
  GDA94_MGA_ZONE_54 = 28354,
  GDA94_MGA_ZONE_55 = 28355,
  GDA94_MGA_ZONE_56 = 28356,
  GDA94_MGA_ZONE_57 = 28357,
  GDA94_MGA_ZONE_58 = 28358,
  NAD83_2011_WISCONSIN_SOUTH_FTUS = 6609,
  NAD83_CSRS_UTM_ZONE_19N = 2960,
  SIRGAS_2000_UTM_ZONE_14N = 31968,
  SIRGAS_2000_UTM_ZONE_23S = 31983,
  SIRGAS_2000_UTM_ZONE_24S = 31984,
  TUREF_TM27 = 5253,
  WGS84 = 4326,
  WGS84_UTM_ZONE_18S = 32718,
  WGS84_UTM_ZONE_19N = 32619,
  WGS84_UTM_ZONE_19S = 32719,
  WGS84_UTM_ZONE_20S = 32720,
  WGS84_UTM_ZONE_21S = 32721,
  WGS84_UTM_ZONE_22S = 32722,
  WGS84_UTM_ZONE_23S = 32723,
  WGS84_UTM_ZONE_24S = 32724,
  WGS84_UTM_ZONE_25S = 32725,
  WGS84_UTM_ZONE_42 = 32642,
  WGS84_UTM_ZONE_43 = 32643,
  WGS84_UTM_ZONE_44 = 32644,
  WGS84_UTM_ZONE_45 = 32645,
  WGS84_UTM_ZONE_46 = 32646,
  WGS84_UTM_ZONE_47 = 32647,
  WGS84_UTM_ZONE_48 = 32648,
  WGS84_UTM_ZONE_49 = 32649,
  WGS84_UTM_ZONE_50N = 32650,
  WGS84_UTM_ZONE_50S = 32750,
  WGS84_UTM_ZONE_51N = 32651,
  WGS84_UTM_ZONE_52N = 32652,
  WGS84_UTM_ZONE_53N = 32653,
  WGS84_UTM_ZONE_54N = 32654,
  WGS84_UTM_ZONE_46S = 32746,
  WGS84_UTM_ZONE_47S = 32747,
  WGS84_UTM_ZONE_48S = 32748,
  WGS84_UTM_ZONE_49S = 32749,
  WGS84_UTM_ZONE_51S = 32751,
  WGS84_UTM_ZONE_52S = 32752,
  WGS84_UTM_ZONE_53S = 32753,
  WGS84_UTM_ZONE_54S = 32754,
}

export enum WGS84Crs {
  name = 'WGS 84',
  epsgCode = '4326',
}

export enum WKTVersion {
  WKT_1 = 'WKT1',
  WKT_2 = 'WKT2',
}

export enum CRSSource {
  VLR = 'VLR',
  EVLR = 'EVLR',
}

export enum CRSResultType {
  WKT = 'WKT',
  EPSG = 'EPSG',
  NAME = 'NAME',
  NONE = 'NONE',
  EPSG_GUESS = 'EPSG-guess',
}

export enum CoordinateSystem {
  WGS84 = 'WGS84',
  UTM = 'UTM',
}

export enum CrsType {
  Geographic = 'geographic',
  Projected = 'projected',
  Geocentric = 'geocentric',
}

export enum Hemisphere {
  NORTH = 'N',
  SOUTH = 'S',
  UNKNOWN = 'UNKNOWN',
}
